// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__3eKGq","shimmer":"Skeleton_shimmer__2zZRP"};